import { basenameFind, getMetaFromJcamp, getTargetProperty, } from "../common.js";
const isotherm = {
    jpath: ['spectra', 'isotherm'],
    find: basenameFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default isotherm;
//# sourceMappingURL=isotherm.js.map